import { myAccountApiService } from "@/src/lib/api-services/myAccountApiServices";

export const Canonical = (canonical) => {
    if (!canonical || typeof canonical !== "string") {
        return "";
    }
    const queryIndex = canonical.indexOf("?");
    if (queryIndex === -1) {
        return canonical;
    } else {
        return canonical.substring(0, queryIndex);
    }
};

export function getRandomImage(array) {
    const randomIndex = Math.floor(Math.random() * array.length);
    return array[randomIndex];
}
export const isEmptyObject = (obj) => Object.values(obj).length === 0;

export function formatTimeWithAmPm(timeString) {
    // Create a Date object with the provided time string
    const time = new Date(`1970-01-01T${timeString}Z`); // Dummy date with time

    let hours = time.getUTCHours(); // Get hours (24-hour format)
    const minutes = time.getUTCMinutes().toString().padStart(2, "0"); // Get minutes, pad with 0 if single digit
    //  const seconds = time.getUTCSeconds().toString().padStart(2, "0"); // Get seconds, pad with 0 if single digit

    const ampm = hours >= 12 ? "PM" : "AM"; // Determine AM or PM

    // Convert 24-hour format to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // If hour is 0, make it 12

    // Return the formatted time string with AM/PM
    return `${hours.toString().padStart(2, "0")}:${minutes} ${ampm}`;
}

export const copyToClipboard = (value) => {
    const textField = document.createElement("textarea");
    textField.innerText = value;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.parentNode.removeChild(textField);
    return value;
};

export function convertTo24HourFormat(timeStr) {
    // Split the time into components
    const [time, modifier] = timeStr.split(" "); // E.g., "08:30 PM" => ["08:30", "PM"]
    let [hours, minutes] = time.split(":").map(Number); // "08:30" => [8, 30]

    // Convert hours to 24-hour format
    if (modifier.toLowerCase() === "pm" && hours !== 12) {
        hours += 12; // Add 12 for PM times, except for 12 PM
    }
    if (modifier.toLowerCase() === "am" && hours === 12) {
        hours = 0; // Midnight case (12 AM)
    }

    // Ensure two-digit format for hours and minutes
    return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}`;
}

export const validateEmail = async (email) => {
    try {
        const emailValidationResult = await myAccountApiService.validateEmail(
            email
        );

        const { success, data } = emailValidationResult || {};

        if (success) {
            const { validateEmail } = data || {};

            if (validateEmail?.status === "invalid") {
                const suggestedEmail =
                    validateEmail?.suggestedEmailAddress || "";
                return {
                    isSuccess: true,
                    isValid: false,
                    email: suggestedEmail,
                    error: null,
                };
            } else {
                const validEmail = validateEmail?.email || "";
                return {
                    isSuccess: true,
                    isValid: true,
                    email: validEmail,
                    error: null,
                };
            }
        }
    } catch (error) {
        return {
            isSuccess: false,
            isValid: false,
            email: null,
            error: error?.response?.data?.message || "Something went wrong",
        };
    }
};

export const getCookieValue = (cookie, name) => {
    const parts = cookie?.split(`; ${name}=`);
    if (!parts) return "";
    if (parts.length === 2) return parts.pop().split(";").shift();
};

export function formatTimeSlot(timeString, slotWidth) {
    // Create a Date object with the provided time string
    const time = new Date(`1970-01-01T${timeString}Z`); // Dummy date with time

    let hours = time.getUTCHours(); // Get hours (24-hour format)
    const minutes = time.getUTCMinutes().toString().padStart(2, "0"); // Get minutes, pad with 0 if single digit
    const seconds = time.getUTCSeconds().toString().padStart(2, "0"); // Get seconds, pad with 0 if single digit
    let endHours = new Date(time.getTime() + slotWidth * 60000).getUTCHours();
    let endMinutes = new Date(time.getTime() + slotWidth * 60000)
        .getUTCMinutes()
        .toString()
        .padStart(2, "0");

    // const endHours = time.addMinutes(60).getUTCHours();

    const ampm = endHours >= 12 ? "PM" : "AM"; // Determine AM or PM

    // Convert 24-hour format to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // If hour is 0, make it 12
    endHours = endHours % 12;
    endHours = endHours ? endHours : 12; // If hour is 0, make it 12

    // Return the formatted time string with AM/PM
    return `${hours.toString().padStart(2, "0")}:${minutes} - ${endHours
        .toString()
        .padStart(2, "0")}:${endMinutes} ${ampm}`;
}

export const loadScript = (src) => {
    return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => {
            resolve(true);
        };
        script.onerror = () => {
            resolve(false);
        };
        document.body.appendChild(script);
    });
};

const DAYS_FULL = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];
const DAYS_SHORT = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTHS_FULL = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
const MONTHS_SHORT = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

export const formatDate = (inputDate, format = "YYYY/MM/DD HH:mm A") => {
    const date = new Date(inputDate);

    if (isNaN(date)) {
        console.error("Invalid date provided:", inputDate);
        return null;
    }
    const year = date.getFullYear();
    const monthIndex = date.getMonth();
    const day = date.getDate();
    const dayIndex = date.getDay();

    const hours24 = date.getHours();
    const minutes = date.getMinutes();
    const hours12 = hours24 % 12 || 12;
    const ampm = hours24 >= 12 ? "PM" : "AM";

    const replacements = {
        dddd: DAYS_FULL[dayIndex],
        ddd: DAYS_SHORT[dayIndex],
        MMMM: MONTHS_FULL[monthIndex],
        MMM: MONTHS_SHORT[monthIndex],
        YYYY: year.toString(),
        MM: String(monthIndex + 1).padStart(2, "0"),
        M: (monthIndex + 1).toString(),
        DD: String(day).padStart(2, "0"),
        D: day.toString(),
        HH: String(hours24).padStart(2, "0"),
        H: hours24.toString(),
        hh: String(hours12).padStart(2, "0"),
        h: hours12.toString(),
        mm: String(minutes).padStart(2, "0"),
        m: minutes.toString(),
        A: ampm,
        a: ampm.toLowerCase(),
    };
    const sortedTokens = Object.keys(replacements).sort(
        (a, b) => b.length - a.length
    );

    let result = format;
    for (const token of sortedTokens) {
        result = result.replace(
            new RegExp(`\\b${token}\\b`, "g"),
            replacements[token]
        );
    }
    return result;
};

export const dateUtils = {
    isAfter(dateToCheck, compareTo = new Date()) {
        return new Date(dateToCheck).getTime() > new Date(compareTo).getTime();
    },

    isTomorrow(dateToCheck) {
        const check = new Date(dateToCheck);
        const tomorrow = new Date();
        tomorrow.setHours(0, 0, 0, 0);
        tomorrow.setDate(tomorrow.getDate() + 1);
        return check.setHours(0, 0, 0, 0) === tomorrow.getTime();
    },

    isYesterday(dateToCheck) {
        const check = new Date(dateToCheck);
        const yesterday = new Date();
        yesterday.setHours(0, 0, 0, 0);
        yesterday.setDate(yesterday.getDate() - 1);

        return check.setHours(0, 0, 0, 0) === yesterday.getTime();
    },

    isTodayOrTomorrow(dateToCheck) {
        const check = new Date(dateToCheck);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);

        check.setHours(0, 0, 0, 0);
        if (check.getTime() === today.getTime()) return 1;
        if (check.getTime() === tomorrow.getTime()) return 2;
        return 0;
    },
};

export const formatDateUTC = (inputDate, format = "YYYY/MM/DD HH:mm A") => {
    const date = new Date(inputDate);
    const year = date.getUTCFullYear();
    const monthIndex = date.getUTCMonth();
    const day = date.getUTCDate();

    const replacements = {
        YYYY: year.toString(),
        MM: String(monthIndex + 1).padStart(2, "0"),
        DD: String(day).padStart(2, "0"),
    };
    let result = format;
    for (const token in replacements) {
        result = result.replace(new RegExp(token, "g"), replacements[token]);
    }
    return result;
};
